












































































































































import IRPTRepportsQueries from '@/store/models/IRPTRepportsQueries';
import IRPTQueries from '@/store/models/IRPTQueries';
import IRPTRepports from '@/store/models/IRPTRepports';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import TableRowAction from '../shared/TableRowAction.vue';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';

@Component({
    components: {
        Snackbar
    }
})
export default class RPTRepportsQueriesSelector extends Vue {
    searchRPTRepportsQueries: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    headers: any = [
        { text: 'Repport', value: 'repportName' },
        { text: 'Query', value: 'queryName' },
        { text: 'Order', value: 'execOrder' },
        { text: 'Actions', value: '' }
    ];
    editedIndex : number = -1;
    editedItem : IRPTRepportsQueries = {
        id: "",
        idRPTRepports: "",
        repportName: "",
        idRPTQueries: "",
        queryName: "",
        execOrder: 0
    }
    defaultItem : IRPTRepportsQueries = {
        id: "",
        idRPTRepports: "",
        repportName: "",
        idRPTQueries: "",
        queryName: "",
        execOrder: 0
    }
    sortBy: string = 'repportName';
    sortDesc: boolean = false;

    @Prop({ type: Array, required: true })
    RPTRepportsQueriesList !: IRPTRepportsQueries[];
    @Prop({ type: Array, required: true })
    RPTQueriesList !: IRPTQueries[];
    @Prop({ type: Array, required: true })
    RPTRepportsList !: IRPTRepports[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];

    selectedRPTRepportsQueries : IRPTRepportsQueries[] = [];
    selectedRepport : IRPTRepports = {} as IRPTRepports;
    selectedQuery : IRPTQueries = {} as IRPTQueries;

    get formTitle() { return this.editedIndex === -1 ? 'New Repport Queries' : 'Edit Repport Queries'; }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    resetRPTRepportsQueries() {
        this.selectedRPTRepportsQueries = [];
        this.selectedRepport = {} as IRPTRepports;
        this.selectedQuery = {} as IRPTQueries;
    }

    editRPTRepportsQueries (item: any, dbox = true) {
        this.editedIndex = this.RPTRepportsQueriesList.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
    }

    saveRPTRepportsQueries (listAdressType: IRPTRepportsQueries) {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            this.editedItem.idRPTRepports = this.selectedRepport.id;
            this.editedItem.repportName = this.selectedRepport.repportName;
            this.editedItem.idRPTQueries = this.selectedQuery.id;
            this.editedItem.queryName = this.selectedQuery.queryName;
            if (this.editedIndex > -1 || this.selectedRPTRepportsQueries[0]) {
                this.close();
                this.$emit('editRPTRepportsQueries', this.editedItem);
                Object.assign(this.RPTRepportsQueriesList[this.editedIndex], this.editedItem);
            } else {
                this.selectedRPTRepportsQueries[0] = this.editedItem;
                this.$emit('saveRPTRepportsQueries', this.editedItem);
            }
            this.close();
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    deleteRPTRepportsQueries (rptQueryParameters: IRPTRepportsQueries) {
        this.$emit('deleteRPTRepportsQueries', rptQueryParameters);
        this.close();
        this.resetRPTRepportsQueries();
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    selectRPTRepportsQueries(item : any) : void {
        if (!this.selectedRPTRepportsQueries.includes(item)) {
            this.selectedRPTRepportsQueries = [];
            this.selectedRPTRepportsQueries = [item];
            this.selectedRepport = this.RPTRepportsList.find(p => p.id === item.id_RPT_Repports) as IRPTRepports;
            this.selectedQuery = this.RPTQueriesList.find(p => p.id === item.id_RPT_Queries) as IRPTQueries;
        } else {
            this.selectedRPTRepportsQueries = [];
        }
    }
    
    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
